<div class="header">
    <h2><strong>Dashboard</strong></h2>
    <div class="breadcrumb-wrapper hidden-xs">
        <ol class="breadcrumb">
            <li class="active">Dashboard</li>
        </ol>
    </div>
</div>
<div class="row">
    <div class="col-md-12">
        <div class="panel">
            <div class="panel-content">
                <h4>Dashboard personalizzabile</h4>
            </div>
        </div>
    </div>
</div>